import { getAuthHeaders } from '../../../actions/authActions';
import tempMeeApi from '../../../apis/tempMee';

export const getPromotionPayouts = async (promotionId) => {
  const headers = await getAuthHeaders();
  const response = await tempMeeApi.get(
    `/payment/admin/promotion-campaigns/${promotionId}/payouts`,
    { headers },
  );

  return response.data;
};
